import React from 'react'
import style from './Footer.module.css';
import { useLocation, NavLink } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import dubiLogo from './dubisignLogo.png';
import { getWebsiteSettings } from '../../Api/commonApis';
import { getOffers } from './../../Api/offers';
import instagram2 from '../../assets/icons/instagram2.svg';
import twitter2 from '../../assets/icons/twitter2.svg';
import facebook2 from '../../assets/icons/facebook2.svg';
import whatsappFooter from '../../assets/icons/whatsapp2.svg';
import linkedIn from '../../assets/icons/linkedIn.svg';
import tiktok from '../../assets/icons/tiktok.svg';
import linktr from '../../assets/icons/linkTree.svg';
import visa1 from '../../assets/icons/visa1.svg';
import visa2 from '../../assets/icons/visa2.svg';
import visa3 from '../../assets/icons/visa3.svg';
import { filterLanguage } from './../../utilities/filterFunction';
import logo from '../../assets/images/logo.png';
import { host_url } from '../../configiration/config';
import { basename } from './../../configiration/config';

function Footer() {
  const [t] = useTranslation();
  const [offers, setOffers] = useState([]);


  const { pathname } = useLocation();
  const [settings, setSettings] = useState();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  // get About us
  useEffect(() => {
    getWebsiteSettings().then((res) => {
      let contacts = { ...settings }
      contacts = res.data.data
      setSettings(contacts);
    })
    // eslint-disable-next-line
  }, []);

  // get About us
  useEffect(() => {
    getOffers().then((res) => {
      let offer = { ...offers }
      offer = res.data.data
      setOffers(offer);
    })
    // eslint-disable-next-line
  }, []);

  return (
    <div>
      {/* START OF DISCOUNT SECTION */}
      {offers && offers.length ? offers.map((offer) => {
        let offerSelected=filterLanguage(offer.locales)
        return (
          <div key={offer.slug} className={`${style.discount}`}>
            <div className={`${style.discountContainer}  d-flex align-items-center `}>
              <div className={`${style.off} d-flex align-items-center`}>
                <img src={`${host_url}/${offer.image}`} alt="" />
                <div className={`${style.offTest} d-flex flex-column align-items-start`}>
                  <h3>{offerSelected && offerSelected.length >0 && offerSelected[0].title}</h3>
                  <span>{offerSelected && offerSelected.length >0 && offerSelected[0].description}</span>
                </div>
              </div>
              <span className={`${style.hidden4Mobile}`}>{offerSelected && offerSelected.length >0 && offerSelected[0].description}</span>
              <div className={`${style.bookingBtn}`}>
                <a href={offer.button_link} target="_blank" rel='noreferrer'>{offerSelected && offerSelected.length >0 && offerSelected[0].button}</a>
              </div>
            </div>
          </div>
        )
      })
        : <div></div>
      }

      {/* END OF DISCOUNT SECTION */}

      {/* START OF FOOTER DETAILS SECTION  */}
      <div className={`${style.myCustomContainer}`}>
        <div className={`${style.footerDetails} d-flex justify-content-between align-items-center flex-wrap`}>
          {settings && (
            <div className={`${style.logo} d-flex flex-column justify-content-between align-items-start`}>
              <img src={`${host_url}/${settings.logo}`} onError={(e) => { e.target.src = logo }}  alt="website_logo" />
            </div>
          )}
          <div className={`${style.payment} d-flex flex-column justify-content-between align-items-start`}>
            <h4>{t('payment-methods')}</h4>
            <div className={`${style.paragraphContainer}`}>
              <p>{t('pay-description')}</p>
            </div>
            <div className={`${style.visas}`}>
              <img src={visa1} alt='payment method' />
              <img src={visa2} alt='payment method' />
              <img src={visa3} alt='payment method' />
            </div>
          </div>
          <div className={`${style.help} d-flex flex-column justify-content-between align-items-start`}>
            <h4>{t('help-center')}</h4>
            <div className='d-flex flex-column justify-content-between align-items-start'>
              <NavLink to={`${basename}/terms-and-conditions`}  className={(navData) => navData.isActive ? `${style.activeFooterLink}` : ""}>{t('terms')}</NavLink>
              <NavLink to={`${basename}/privacy-policy`} className={(navData) => navData.isActive ? `${style.activeFooterLink}` : ""}>{t('privacy')}</NavLink>
              <NavLink to={`${basename}/faq`} className={(navData) => navData.isActive ? `${style.activeFooterLink}` : ""}>{t('faq')}</NavLink>
            </div>
          </div>
          {settings &&
            <div className={`${style.contact} d-flex flex-column justify-content-between align-items-start`}>
              <h4>{t('contact')}</h4>
              <a href={`tel:${settings.phone}`}>P: +{settings.phone}</a>
              <a href={`mailto:${settings.email}`} target='_blank' rel='noreferrer'>E: {settings.email}</a>

              <div className={`${style.social}`}>
                {settings.instagram &&
                  <a href={settings.instagram} target="_blank" rel='noreferrer'>
                    <img src={instagram2} alt='instagram'/>
                  </a>
                }
                {settings.twitter &&
                  <a href={settings.twitter} target="_blank" rel='noreferrer'>
                    <img src={twitter2} alt='twitter'/>
                  </a>
                }
                {settings.facebook &&
                  <a href={settings.facebook} target="_blank" rel='noreferrer'>
                    <img src={facebook2} alt='facebook'/>
                  </a>
                }
                {settings.whatsapp &&
                  <a href={`https://wa.me/${settings.whatsapp}`} target="_blank" rel='noreferrer'>
                    <img src={whatsappFooter} alt='whatsapp'/>
                  </a>
                }
                {settings.linkedin &&
                  <a href={settings.linkedin} target="_blank" rel='noreferrer'>
                    <img src={linkedIn} alt='linked in'/>
                  </a>
                }
                {settings.tiktok &&
                  <a href={settings.tiktok} target="_blank" rel='noreferrer'>
                    <img src={tiktok} alt='tiktok'/>
                  </a>
                }
                {settings.linktr &&
                  <a href={settings.linktr} target="_blank" rel='noreferrer'>
                    <img src={linktr} alt='link tree'/>
                  </a>
                }
              </div>
            </div>
          }
        </div>
      </div>
      {/* END OF FOOTER DETAILS SECTION  */}
      {/* DUBI CRDEITS */}
      <div className={`${style.credits}`}>
        {settings && (
          <>
            <span>{settings && settings.copyright && filterLanguage( settings.copyright.locales)[0].title}</span> <span>{t(`powered_by`)} </span>
            <a href="https://dubisign.ae" target='_blank' rel='noreferrer'>
              <span className={`${style.dubi}`}>{t(`dubisign`)}</span>
              <img src={dubiLogo} className={style.dubiLogo} alt="developer_logo" />
            </a>
            
          </>
        )}
      </div>
    </div>

  )
}

export default Footer